
import get from 'lodash/get'
import { defineComponent, useContext } from '@nuxtjs/composition-api'
import { mapGetters, mapMutations } from 'vuex'
import { routerQueryIsEqual } from '~/assets/composition/setup-dynamic-url'
import { setupPrepareTixPricing, setupPrepareTixSale } from '~/assets/composition/tix'
import { setupGtmFilterSelect, setupGtmViewItemListWatcher } from '~/assets/composition/setup-gtm'
import { setupTranslationPrefixer } from '@/assets/util'

export default defineComponent({
  props: {
    breadcrumbs: { type: Array, required: true },
    limit: { type: Number, required: false, default: 15 },
    page: { type: Object, required: true },
  },
  setup() {
    setupGtmViewItemListWatcher('event-overview/events')
    setupGtmFilterSelect()

    const { $cookies } = useContext()
    let experiment = null
    const eventOverviewTemplateCookie = $cookies.get('event_overview_v2')
    if (typeof eventOverviewTemplateCookie === 'boolean' && eventOverviewTemplateCookie) {
      experiment = 'V2'
    }

    // const store = useStore()
    // const experiment = computed(() => store.state.experiments.cv07)

    return {
      ...setupTranslationPrefixer('EventOverview'),
      prepareTixPricing: setupPrepareTixPricing(),
      prepareTixSale: setupPrepareTixSale(),
      experiment,
    }
  },
  computed: {
    ...mapGetters({
      activeFacets: 'event-overview/activeFacets',
      bannersAtPosition: 'event-overview/bannersAtPosition',
      currentPage: 'event-overview/page',
      eventsByDay: 'event-overview/eventsByDay',
      facets: 'event-overview/facets',
      hitsPerPage: 'event-overview/hitsPerPage',
      keyword: 'event-overview/keyword',
      topEvents: 'event-overview/topEvents',
      totalHits: 'event-overview/totalHits',
      urlParameters: 'event-overview/urlParameters',
    }),
  },
  watch: {
    '$route.query'(query) {
      if (!routerQueryIsEqual(this.urlParameters, query)) {
        this.setUrlParameters(query)
      }
    },
    urlParameters(query) {
      if (!routerQueryIsEqual(this.$route.query, query)) {
        this.$router.push({ query })
      }
    },
  },
  methods: {
    ...mapMutations({
      reset: 'event-overview/reset',
      setCurrentPage: 'event-overview/setPage',
      setUrlParameters: 'event-overview/setUrlParameters',
      setKeyword: 'event-overview/setKeyword',
      toggleFacet: 'event-overview/toggleFacet',
    }),
    get,
  },
})
